<template>
	<div class="main">
		<header class="page-title">
			<h2>Create new stats provider</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('dashboard_access.create')" href="#" class="btn btn-md btn-success" @click="addProvider">
					<i class="fas fa-save"></i> Add Provider
				</a>
			</div>
		</header>

		<div class="flex box">
			<div class="eight-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">General Information</h3>
					</header>
					<div class="card-body">
						<div class="flex box">
							<div class="nine">
								<div class="flex box">
									<div class="form-group six">
										<label for="name">Provider Name</label>
										<input id="name" name="name" @keyup="refreshSlug(provider.name)" type="text" required v-model="provider.name">
										<p class="input-error" v-if="errors.errors.name">{{ errors.errors.name }}</p>
									</div>
									<div class="form-group six">
										<label for="slug">Provider Slug</label>
										<input disabled class="input-small" id="slug" name="slug" type="text" required v-model="provider.slug">
										<p class="input-error" v-if="errors.errors.slug">{{ errors.errors.slug }}</p>
									</div>
								</div>
								<div class="form-group">
									<label for="affiliate-type">Affiliate type</label>
									<select id="affiliate-type" name="affiliate-type" v-model="provider.stats_affiliate_type_id">
										<option v-for="type in affiliateTypes" :key="provider.stats_affiliate_type_id" :value="type.id">
											{{ type.name }}
										</option>
									</select>
									<p class="input-error" v-if="errors.errors.stats_affiliate_type_id">{{ errors.errors.stats_affiliate_type_id }}</p>
								</div>
								<div class="form-group">
									<label for="state">Provider</label>
									<label class="state">
										<input id="state" name="state" type="checkbox" v-model="provider.state"> State
									</label>
									<p class="input-error" v-if="errors.errors.state">{{ errors.errors.state }}</p>
								</div>
								<div class="form-group">
									<label for="account_email">Email Address</label>
									<input id="account_email" name="account_email" type="email" value="" v-model="provider.account_email">
								</div>
								<div class="form-group">
									<label for="custom_field">Custom field</label>
									<input id="custom_field" name="custom_field" type="text" value="" v-model="provider.custom_field">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<aside class="four-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Affiliate Access</h3>
					</header>
					<div class="card-body">
						<form>
							<div class="form-group">
								<label for="account_password">Password</label>
								<input id="account_password" name="account_password" type="text" v-model="provider.account_password">
							</div>
							<div class="form-group">
								<label for="account_api_key">Api key</label>
								<input id="account_api_key" name="account_api_key" type="text" v-model="provider.account_api_key">
							</div>
							<div class="form-group">
								<label for="request_url">Request URL:</label>
								<input id="request_url" name="request_url" type="text" v-model="provider.request_url">
							</div>
						</form>
					</div>
				</div>
			</aside>
		</div>
	</div>
</template>

<script>
import Slug from "../../Utils/Slug";
import Errors from '../../Utils/Errors.js';

export default {
	name: "StatsProviderCreate",
	props: {
		dataAffiliateTypes: {
			type: Array
		}
	},
	data() {
		return {
			provider: {
				name: '',
				slug: '',
				stats_affiliate_type_id: null,
				state: true,
				account_email: '',
				custom_field: '',
				account_password: '',
				account_api_key: '',
				request_url: ''
			},
			affiliateTypes: this.dataAffiliateTypes,
			userRoles: this.$currentUserRoles,
			errors: new Errors()
		}
	},
	methods: {
		addProvider: function () {
			axios.post('/api/' + this.$selectedSite.slug + '/statsProvider', this.provider)
				.then(response => {
					this.$toastr.success('Provider saved successfully', 'Success');
				})
				.catch(e => {
					this.errors.record(e.response.data);
					this.$toastr.error('Provider save failed.', e.response.data.message);
				});
		},
		refreshSlug: function (name) {
			let slug = new Slug();
			this.provider.slug = slug.refreshSlug(name)
		}
	}
}
</script>

<style scoped>

</style>
